<button
  type="button"
  class="btn-cancel btn-sm whitespace-nowrap"
  [disabled]="!pathBar.canMoveBarToFilter()"
  (click)="pathBar.moveBarToFilter()">
  {{ 'features.data.path_filter.panel.move_to_filter' | translate }}
</button>
<button
  type="button"
  class="btn-cancel btn-sm whitespace-nowrap"
  [disabled]="!pathBar.canMoveFilterToBar()"
  (click)="pathBar.moveFilterToBar()">
  {{ 'features.data.path_filter.panel.move_to_bar' | translate }}
</button>
